import PartnerDetail from './PartnerDetail';

export default PartnerDetail;
